module.exports = __webpack_public_path__ + "img/237.3eaf5d84.jpg";